import React, { useState } from 'react';
import styles from './styles.styl';
import cn from 'classnames/bind';
import { Text } from '@consta/uikit/Text';
import { IconArrowDown } from '@consta/uikit/IconArrowDown';
import { IAnalyticResultTableEntity } from 'src/redux/features/analytic/types';
import { formatDate } from 'src/utils';
import AnalyticsQuestionItem from 'src/components/AnalyticsQuestionItem/AnalyticsQuestionItem';
import { useSelector } from 'react-redux';
import { State } from 'src/redux/reducer';
import { SurveyTypeEnum } from 'src/utils/enum';
import { Badge } from '@consta/uikit/Badge';

export interface IAnalyticsUserAnswersCartProps {
  data: IAnalyticResultTableEntity;
}

const cx = cn.bind(styles);

const AnalyticsUserAnswersCart: React.FC<IAnalyticsUserAnswersCartProps> = ({
  data,
}) => {
  const status = data?.points >= data?.passingScore;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const typeEntity = useSelector((state: State) => state.analytic.data.type);
  return (
    <div className={cx('AnalyticsUserAnswersCart')}>
      <div>
        <div className={cx('AnalyticsUserAnswersCart__container')}>
          <div className={cx('AnalyticsUserAnswersCart__header')}>
            <div className={cx('AnalyticsUserAnswersCart__label')}>
              <IconArrowDown
                onClick={() => setIsOpen(!isOpen)}
                view="secondary"
                className={cx('AnalyticsUserAnswersCart__arrow', {
                  AnalyticsUserAnswersCart__arrow_active: isOpen,
                })}
              />
              <Text>№ {data?.number}</Text>
              <Text view="ghost">{formatDate(new Date(data?.date))}</Text>
            </div>
            {typeEntity === SurveyTypeEnum.TEST && (
              <div className={cx('AnalyticsUserAnswersCart__status')}>
                <Text>Баллов: {data?.points}</Text>
                <Badge
                  label={`${status ? '' : 'НЕ '}ПРОЙДЕН`}
                  status={status ? 'success' : 'error'}
                />
              </div>
            )}
          </div>
          <div className={cx('AnalyticsUserAnswersCart__question')}>
            <AnalyticsQuestionItem
              type={data.questions[0]?.type}
              question={data.questions[0]?.title}
              userAnswers={data.questions[0]?.answer}
              answers={data.questions[0]?.answers}
              is_required={data.questions[0]?.is_required}
              rating={data.questions[0]?.rating}
              isTitle={true}
            />
          </div>
          {isOpen && (
            <div className={cx('AnalyticsUserAnswersCart__content')}>
              {data.questions.map((item, index) => (
                <AnalyticsQuestionItem
                  number={index + 1}
                  key={index}
                  type={item.type}
                  question={item.title}
                  comment={item.comment}
                  userAnswers={item.answer}
                  answers={item.answers}
                  is_required={item?.is_required}
                  rating={item?.rating}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsUserAnswersCart;
